import { reserveSeatsWithServices } from '../../../services/customer/ticketBookingServices';

function handlePassengerServices({
  passenger, services, statement, reserveData, isCustomerBooking = false,
}) {
  const { additional_services: passengerServices } = passenger;
  if (passengerServices) {
    let statementSeat = statement?.statementRides?.[0]?.statementSeats?.find((seat) => {
      const statementSeatDetail = isCustomerBooking ? seat.statementSeatDetail : seat;
      return +statementSeatDetail.seatNumber === +passenger.seat_number
          && +statementSeatDetail.carriageId === +passenger.carriage_id;
    });
    if (!statementSeat) {
      statementSeat = statement?.statementRides?.[1]?.statementSeats?.find((seat) => {
        const statementSeatDetail = isCustomerBooking ? seat.statementSeatDetail : seat;
        return +statementSeatDetail.seatNumber === +passenger.seat_number
            && +statementSeatDetail.carriageId === +passenger.carriage_id;
      });
    }
    Object.keys(passengerServices).forEach((key) => {
      if (passengerServices[key]) {
        const service = services?.find((s) => +s.id === +key);
        if (service) {
          reserveData.services.push({
            amount: service.amount,
            quantity: 1,
            serviceId: service.serviceId,
            tariffMultiplyValueId: 1,
            statementSeatId: statementSeat.id,
          });
        }
      }
    });
  }
}
export default async function reserveSeatsWithAdditionalServices({
  departurePassengersForm,
  returnPassengersForm,
  bookingData,
  statement,
  services,
  setStatement,
  nextStep,
}) {
  const reserveData = {
    departure_passengers: departurePassengersForm.getFieldValue('passengers'),
    departure_ride_id: bookingData?.departure?.id ?? bookingData?.departure?.rideId,
    return_passengers: [],
    statement_id: statement?.id,
    statementGuid: statement?.statementGuid,
    services: [],
  };
  reserveData.departure_passengers.forEach((passenger) => handlePassengerServices({
    passenger, services, statement, reserveData,
  }));
  if (returnPassengersForm) {
    reserveData.return_ride_id = bookingData?.return?.id ?? bookingData?.return?.rideId;
    reserveData.return_passengers = returnPassengersForm.getFieldValue('passengers');
    reserveData.return_passengers.forEach((passenger) => handlePassengerServices({
      passenger, services, statement, reserveData,
    }));
  }
  const res = await reserveSeatsWithServices(reserveData);
  if (res.messageText === 'success') {
    setStatement(res.data);
    nextStep();
  }
}
